<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info">
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="columns is-mobile is-marginless is-multiline color-icon">
          <div class="column is-12 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="map-marker"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Adresse
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{adresse}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Format
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailReseauxNumeriqueComplet.format}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="package-variant-closed"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Matériel
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailReseauxNumeriqueComplet.materiel}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatEclaire, formatAdresse, urlPhoto } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxNumeriqueComplet',
  props: ['detailReseauxNumeriqueComplet'],
  data() {
    return {
      active: 1,
      select: true,
    };
  },
  computed: {
    eclaire() {
      return formatEclaire(this.detailReseauxNumeriqueComplet.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailReseauxNumeriqueComplet);
    },
    url() {
      return urlPhoto(this.detailReseauxNumeriqueComplet.urlPhoto);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxNumeriques/detailReseauxNumeriqueComplet.vue